export default class Address {
  public line1 = ''
  public line2 = ''
  public postcode = ''
  public city = ''
  public state = ''
  public country = ''
}
